import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';
import {appRoutes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideHttpClient, withInterceptors, withXhr} from '@angular/common/http';
import {provideApi, withBackendApiConfiguration} from './common/api/api.provider';
import {provideCharts, withDefaultRegisterables} from 'ng2-charts';
import {environment} from './environments/environment';
import {registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE, provideNativeDateAdapter} from '@angular/material/core';
import {GERMAN_DATE_FORMATS} from './pages/dashboard/utils/date-formats';
import {
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  includeBearerTokenInterceptor,
  provideKeycloak,
} from 'keycloak-angular';

registerLocaleData(localeDe);

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: /.*/,
  bearerPrefix: 'Bearer',
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(appRoutes),
    provideAnimationsAsync(),
    provideApi(
      withBackendApiConfiguration({
        rootUrl: environment.apiBaseUrl,
      }),
    ),
    provideCharts(withDefaultRegisterables()),
    provideNativeDateAdapter(),
    {provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
    {provide: MAT_DATE_FORMATS, useValue: GERMAN_DATE_FORMATS},
    provideKeycloak({
      config: {
        url: 'https://id.energyplus.at/',
        realm: 'energy',
        clientId: 'app',
      },
      initOptions: {
        onLoad: 'login-required',
      },
    }),
    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [urlCondition],
    },
    provideHttpClient(withXhr(), withInterceptors([includeBearerTokenInterceptor])),
  ],
};
